<template>
    <div class="base-layout d-flex flex-column justify-content-center  paw">
        <div class="base-layout-header flex-grow-0">
            <div class="d-flex justify-content-center">
                <div class="p-3 text-center"><h4>{{ appTitle }}</h4></div>
            </div>
        </div>
        <div class="flex-grow-1 d-flex flex-column justify-content-center align-items-center align-content-center">
            <transition name="page-custom" mode="out-in" :key="$router.currentRoute.fullPath">
                <router-view> </router-view>
            </transition>
        </div>
        <div class="flex-grow-0 bg-dark text-light">
            <div class="d-flex p-5">
                <div class="flex-grow-1">{{ appTitle }}</div>
                <div class="flex-grow-0">&copy; ГОБУ ЦИТ МО, {{ currentYear }}</div>
            </div>
        </div>
    </div>
</template>

<script>
    // import { Toast } from 'vuex-toast';

    import paw from '@/assets/img/animal_placeholder.png'

    export default {
        name: "BaseLayout",
        data() {
            return {
                paw: paw
            }
        },
        computed: {
            appTitle: function () {
                return process.env.VUE_APP_TITLE;
            },
            currentYear: function () {
                return new Date().getFullYear();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import 'node_modules/bootstrap/scss/bootstrap.scss';
    .base-layout {
        min-height: 100vh;
        background-color: $light;
    }

    .page-custom-enter-active, .page-custom-leave-active {
      transition: opacity 0.3s, transform 0.5s;
    }
    .page-custom-enter, .page-custom-leave-to {
      opacity: 0;
      transform: translateX(-30%);
    }

    .paw {
        background: url('../../assets/img/paw.png');

    }

</style>